import React from "react";

const paths = {
    arrow: (
        <>
            <path d="M4 12h16M14 6l6 6-6 6" />
        </>
    ),
    diagonal: (
        <>
            <path d="M6 18 18 6M6 6h12v12" />
        </>
    ),
    down: (
        <>
            <path d="M12 4v16M6 14l6 6 6-6" />
        </>
    ),
    pin: (
        <>
            <path d="M20 10c0 6-8 11-8 11S4 16 4 10a8 8 0 1 1 16 0Z" />
            <circle cx="12" cy="10" r="2.5" />
        </>
    ),
    clock: (
        <>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
        </>
    ),
    sun: (
        <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5" />
        </>
    ),
    growth: (
        <>
            <path d="M4 20h16M6 16v-3m6 3V9m6 7V4M4 9l7-6" />
        </>
    ),
    team: (
        <>
            <circle cx="9" cy="8" r="3" />
            <path d="M3 21v-3a6 6 0 0 1 12 0v3M16 5a3 3 0 0 1 0 6m2 4a5 5 0 0 1 3 4v2" />
        </>
    ),
    check: <path d="m5 12 4 4L19 6" />,
    mail: (
        <>
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <path d="m3 7 9 6 9-6" />
        </>
    ),
    briefcase: (
        <>
            <rect x="3" y="7" width="18" height="14" rx="2" />
            <path d="M8 7V3h8v4M3 12c6 4 12 4 18 0M12 12v4" />
        </>
    ),
    education: (
        <>
            <path d="m2 9 10-5 10 5-10 5L2 9Zm4 2v6c4 3 8 3 12 0v-6m4-2v8" />
        </>
    ),
};

export default function Icon({ name = "arrow", className = "" }) {
    return (
        <svg
            className={`icon ${className}`}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            {paths[name] || paths.arrow}
        </svg>
    );
}
